import Query from "../utils/Query";

export default class FileService {

	static getAll() {
		return Query.get('/files');
	}

	static upload(files = [], onProgress = () => {}) {
		return Query.upload(files);
	}
}
